var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPrinter(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Gruppe_16",
    "data-name": "Gruppe 16",
    xmlns: "http://www.w3.org/2000/svg",
    width: 73.034,
    height: 73.034,
    viewBox: "0 0 73.034 73.034",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_15",
    "data-name": "Pfad 15",
    d: "M0,0H73.034V73.034H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_16",
    "data-name": "Pfad 16",
    d: "M53.733,18.216h-42.6A9.117,9.117,0,0,0,2,27.345V45.6H14.172V57.776H50.69V45.6H62.862V27.345A9.117,9.117,0,0,0,53.733,18.216ZM44.6,51.69H20.259V36.474H44.6Zm9.129-21.3a3.043,3.043,0,1,1,3.043-3.043A3.052,3.052,0,0,1,53.733,30.388ZM50.69,3H14.172V15.172H50.69Z",
    transform: "translate(4.086 6.129)",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPrinter);
export default __webpack_public_path__ + "static/media/icon-printer.b3f863415418dc904249393a00989f97.svg";
export { ForwardRef as ReactComponent };